export const TRANSACTION_STATUS = {
  processing: 'processing',
  ok: 'ok',
  error: 'error',
} as const;
